import { render, staticRenderFns } from "./DeleteEducationEntryDialog.vue?vue&type=template&id=8e04f378&"
import script from "./DeleteEducationEntryDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteEducationEntryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports